import React from 'react';
import { Color, PieceType } from '../../engine/types';
import Piece from './Piece';
import './PromotionDialog.css';

interface PromotionDialogProps {
  color: Color;
  onSelect: (pieceType: PieceType) => void;
}

const PromotionDialog: React.FC<PromotionDialogProps> = ({ color, onSelect }) => {
  const promotionPieces: PieceType[] = [
    PieceType.Queen,
    PieceType.Rook,
    PieceType.Bishop,
    PieceType.Knight,
  ];

  return (
    <div className="promotion-dialog-overlay">
      <div className="promotion-dialog">
        <h3 className="promotion-title">Choose Promotion Piece</h3>
        <div className="promotion-options">
          {promotionPieces.map((pieceType) => (
            <button
              key={pieceType}
              className="promotion-button"
              onClick={() => onSelect(pieceType)}
              aria-label={`Promote to ${PieceType[pieceType]}`}
            >
              <Piece type={pieceType} color={color} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PromotionDialog;
